import { z } from 'zod';

export const SipTrunkConfigurationCleanupSchema = z.discriminatedUnion('state', [
  z.object({ state: z.literal('completed') }).strict(),
  z.object({
    state: z.literal('not_completed'),
    reason: z.enum(['identity_conflict', 'configuration_error']),
  }).strict(),
]);

export type SipTrunkConfigurationCleanup = z.infer<typeof SipTrunkConfigurationCleanupSchema>;

export const SipTrunkDeleteResponseSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  configuration_cleanup: SipTrunkConfigurationCleanupSchema,
}).strict();

export type SipTrunkDeleteResponse = z.infer<typeof SipTrunkDeleteResponseSchema>;
